import Snappy from '../../../libs/snappy/snappy';

import $ from 'jquery';
import { setTimeout } from 'timers';



Snappy.Component.EduFindlearning = class EduFindlearning extends Snappy.BaseComponent {

    static get tagName() {

        return 'edu-find-learning';

    }



    constructor(element) {

        super(element);

    }



    render() {

        this.setVars();

        this.setEventListeners();



        this.onButtonSearch();
        this.onDdlDiscipline();
        this.onShowNextMonthResult();
        this.onDatePickerField();
        this.onClearAllField();
        this.onMoreDetailsClick();
       // this.onPostCodeField();
        //this.onddlCountyField();
        this.onddlRangeField();
        this.onPopupWindow();


    }

    setVars() {

    }

    setEventListeners() {

    }

    onPopupWindow() {

        $(document).ready(function () {
            if (window.location.href.indexOf("isUserQualified=false") > -1) {
                $('#memberModal').modal('show');
            }
        });

    }

    onButtonSearch() {
        // alert("onButtonSearch");
        // var snappyObject = this;
        $(document).on('click', "#btnSearch", function (evt) {
            // this.onDatePickerField();


            var discipline = $("#ddlDiscipline").val();
            var level = $("#ddlLevel").val();
            var selectedMonth = $("#ddlDate").val();
            //var county = $("#ddlCounty").val().toLowerCase();
            var PostCodeLat = $("#Lat").val();
            var PostCodeLng = $("#Lng").val();
            var PostCode = $("#PostCode").val();
            var range = $("#ddlRange").val();
            //if (county != "") {
            //    PostCodeLat = ""; PostCodeLng = ""; PostCode = ""; range = "";
            //}

            $.ajax({
                url: "/api/sitecore/EduHubFindLearning/GetAvailableCourses?discipline=" + discipline + "&level=" + level + "&startMonth=" + selectedMonth  
                    + "&postcode=" + PostCode + "&postCodeLat=" + PostCodeLat + "&postCodeLon=" + PostCodeLng + "&radius=" + range,
                type: "GET",
                dataType: 'html',

                success: function (data) {
                    $("#availability").html(data);

                    // snappyObject.onDatePickerField();

                },
                error: function () {

                    console.log("Error on Get Available Courses Ajax Call");
                },
            });
            evt.stopImmediatePropagation();
        });

    }
    onShowNextMonthResult() {

        $(document).on('click', "#showNextMonthResult", function (evt) {
            // alert("please fix being tough");
            var discipline = $("#ddlDiscipline").val();
            var level = $("#ddlLevel").val();
            var selectedMonth = $("#hidNextMonthYear").val();
            //var county = $("#ddlCounty").val().toLowerCase();
            var PostCodeLat = $("#Lat").val();
            var PostCodeLng = $("#Lng").val();
            var PostCode = $("#PostCode").val();
            var range = $("#ddlRange").val();
            //if (county != "") {
            //    PostCodeLat = ""; PostCodeLng = ""; PostCode = ""; range = "";
            //}
            $.ajax({
                url: "/api/sitecore/EduHubFindLearning/GetAvailableCourses?discipline=" + discipline + "&level=" + level + "&startMonth=" + selectedMonth 
                    + "&postcode=" + PostCode + "&postCodeLat=" + PostCodeLat + "&postCodeLon=" + PostCodeLng + "&radius=" + range,
                type: "GET",
                dataType: 'html',

                success: function (data) {
                    $("#availability").html(data);

                },
                error: function () {
                    console.log("Error on Get Available Courses Ajax Call");
                },
            });

            evt.stopImmediatePropagation();
        });

    }


    onDdlDiscipline() {


        $(document).on('change', "#ddlDiscipline", function (evt) {
            var discipline = $("#ddlDiscipline").val();
            //alert(discipline);
            $.ajax({
                url: "/api/sitecore/EduHubFindLearning/GetAvailableLevels?discipline=" + discipline,
                type: "GET",
                dataType: 'json',

                success: function (data) {
                    var obj = JSON.parse(data);
                    if (obj != null) {
                        $('#ddlLevel').empty();
                        var buildHtml = '';
                        for (var i in obj) {
                            buildHtml += '<option value="' + obj[i] + '">' + i + '</option>';
                        }
                        $('#ddlLevel').html(buildHtml);
                    }
                },
                error: function () {
                    console.log("Error on Get Available Levels Ajax Call");
                },
            });
            evt.stopImmediatePropagation();
        });

    }

    onDatePickerField() {
        $.noConflict();
        var datePickerTimer = setInterval(function () {
            //alert("set---interval");
            // alert(typeof (jQuery('#datepicker').datepicker));
            if (typeof ($('#datepicker').datepicker) != 'undefined') {
                clearInterval(datePickerTimer);
                //alert("if class----");


                var user_busy_days = [];
                $(".course-part.calendarValue").each(function () {

                    user_busy_days.push($(this).attr('data-startdate'));
                });
                // ale
                var tempDate = user_busy_days[0].split('-');
                var defaultValue = new Date(tempDate[0], (parseInt(tempDate[1]) - 1), tempDate[2]);

                $('#datepicker').datepicker({

                    todayHighlight: true,
                    todayBtn: true,
                    autoclose: true,
                    weekStart: 1,
                    startDate: defaultValue,

                    beforeShowDay: function (date) {

                        calender_date = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2);

                        var search_index = $.inArray(calender_date, user_busy_days);
                        //alert(calender_date);
                        //  console.log(calender_date +'/'+ user_busy_days);
                        if (search_index > -1) {
                            return { classes: 'highlight' };
                        }

                    }
                })

            };
        }, 1000);

    }
    onClearAllField() {
        $(".clear-all a").on('click', function (e) {
            e.preventDefault();
            $("#st").val("");
            // $("#st").val("");
            //$('#ddlCounty').prop("disabled", false);
            $('#ddlRange').prop("disabled", true);
            $('select').each(function () {

                $(this).find('option').first().attr("selected", "selected");

                $('#st').prop("disabled", false);

            });

            $('select option').prop('selected', function () {
                //alert('select----value');
                return this.defaultSelected;
                $('#st').prop("disabled", false);

            })

        });
    }

    onMoreDetailsClick() {

        $(document).on('click', ".book-course .more-details  a", function () {

            if ($(this).attr('aria-expanded') === "true") {

                $(this).closest(".book-course").addClass("book_bg_color");
            }

            else {

                $(this).closest(".book-course").removeClass("book_bg_color");

            }

        });
        $(document).on('click', ".book-course .more-details  a", function () {

            $(this).closest(".book-course").find(".expanded-value").css('display', 'none');

            if ($(window).width() > 992) {

                if ($(this).attr('aria-expanded') === "true") {


                    $(this).closest(".book-course").find(".expanded-value").css('display', 'block');
                    $(this).closest(".book-course").find(".left-value-part").css('display', 'none');
                }

                else {

                    $(this).closest(".book-course").find(".expanded-value").css('display', 'none');
                    $(this).closest(".book-course").find(".left-value-part").css('display', 'block');
                }

            }

        });

    }


    //onPostCodeField() {

    //    $(document).on('change', "#ddlCounty", function () {

    //        if ($(this).val() !== '') {
    //            $('#st').prop("disabled", true);

    //        } else {
    //            $('#st').prop("disabled", false);
    //        }
    //    });

    //}
    //onddlCountyField() {

    //    $(document).on('keypress  change', "#st", function () {

    //        if ($(this).val() !== '') {
    //            $('#ddlCounty').prop("disabled", true);

    //        } else {
    //            $('#ddlCounty').prop("disabled", false);
    //        }
    //    });
    //    $(document).on('keypress change', "#Lat", function () {

    //        if ($(this).val() !== '') {
    //            $('#ddlCounty').prop("disabled", true);

    //        } else {
    //            $('#ddlCounty').prop("disabled", false);
    //        }
    //    });
    //    $(document).on('keypress  change', "#Lng", function () {

    //        if ($(this).val() !== '') {
    //            $('#ddlCounty').prop("disabled", true);

    //        } else {
    //            $('#ddlCounty').prop("disabled", false);
    //        }
    //    });
    //    $(document).on('keypress  change', "#sd", function () {

    //        if ($(this).val() !== '') {
    //            $('#ddlCounty').prop("disabled", true);

    //        } else {
    //            $('#ddlCounty').prop("disabled", false);
    //        }
    //    });
    //    $(document).on('keypress  change', "#PostCode", function () {

    //        if ($(this).val() !== '') {
    //            $('#ddlCounty').prop("disabled", true);

    //        } else {
    //            $('#ddlCounty').prop("disabled", false);
    //        }
    //    });
    //}

    onddlRangeField() {
        $('#ddlRange').prop("disabled", true);
        $(document).on('keypress  change', "#st", function () {

            if ($(this).val() !== '') {
                $('#ddlRange').prop("disabled", false);

            } else {
                $('#ddlRange').prop("disabled", true);
            }
        });
        $(document).on('keypress  change', "#Lan", function () {

            if ($(this).val() !== '') {
                $('#ddlRange').prop("disabled", false);

            } else {
                $('#ddlRange').prop("disabled", true);
            }
        });
        $(document).on('keypress  change', "#Lng", function () {

            if ($(this).val() !== '') {
                $('#ddlRange').prop("disabled", false);

            } else {
                $('#ddlRange').prop("disabled", true);
            }
        });
        $(document).on('keypress  change', "#sd", function () {

            if ($(this).val() !== '') {
                $('#ddlRange').prop("disabled", false);

            } else {
                $('#ddlRange').prop("disabled", true);
            }
        });
        $(document).on('keypress  change', "#PostCode", function () {

            if ($(this).val() !== '') {
                $('#ddlRange').prop("disabled", false);

            } else {
                $('#ddlRange').prop("disabled", true);
            }
        });

    }



}





// WEBPACK FOOTER //
// ./components/edu-find-learning-results/scripts/edu-find-learning.js